import { FlightResponse, PatchFlightType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export type PatchFlightPayload = PatchFlightType

export const usePatchFlight = () => {
	const queryClient = useQueryClient()

	return useMutation<FlightResponse, Error, { tripId: string; flightId: number; data: PatchFlightPayload }>({
		mutationFn: async ({ tripId, flightId, data }) => {
			const response = await api.patch<FlightResponse>(`/trips/${tripId}/flights/${flightId}`, data)
			return response.data
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.flights(variables.tripId) })
		},
	})
}
